import Cookies from 'js-cookie';

// src/identity-cookie.ts
var TRACKING_IDENTIFIER_COOKIE_NAME = "wl-identity";
var getTrackingIdentifier = (options = {}) => {
  const cookieValue = getTrackingIdentifierFromCookie();
  if (cookieValue === void 0 && options.generateCookieOnDefault) {
    return generateTrackingIdentifier(options.pregeneratedTrackingIdentifier);
  }
  return cookieValue;
};
var getTrackingIdentifierFromCookie = () => {
  const cookieValue = Cookies.get(TRACKING_IDENTIFIER_COOKIE_NAME);
  if (cookieValue) {
    try {
      const parsedCookie = JSON.parse(cookieValue);
      return parsedCookie.deviceId;
    } catch (e) {
      return void 0;
    }
  }
  return cookieValue;
};
var generateTrackingIdentifier = (uuid) => {
  const trackingId = uuid ?? crypto.randomUUID();
  const trackingIdentifierCookieValue = { deviceId: trackingId };
  Cookies.set(TRACKING_IDENTIFIER_COOKIE_NAME, JSON.stringify(trackingIdentifierCookieValue), { expires: 365, domain: ".workleap.com" });
  return trackingId;
};

export { TRACKING_IDENTIFIER_COOKIE_NAME, getTrackingIdentifier };
